import { AccessPriviledgeContent } from "../Add/AccessPrivilage/AccessPriviledgeContent";
import { transformString } from "../commonfunctions/transformString";
import useTranslation from "../CustomHooks/useTranslation";
import PTagFramer from "../framerMotion/PTagFramer";

interface CheckBoxWithLabelProps {
  label?: string;
  handelCheckBox?: (id: string, checked: boolean) => void; // Optional callback function
  checked: boolean;
  disabled?: boolean;
  id?: string;
  fontWeight?: string;
  textClassName?: string;
  error?: boolean;
}


export default function CheckBoxWithLabel({
  label,
  handelCheckBox,
  checked,
  disabled,
  id,
  textClassName,
  fontWeight,
  error
}: CheckBoxWithLabelProps) {
  const { translate, notEnglish } = useTranslation(AccessPriviledgeContent)
  return (
    <PTagFramer>
      {label &&<div className={`relative my-2 flex items-center ${(error && !disabled) ? 'label-checkbox-error' : ''} ${disabled ? 'label-checkbox-disabled' : 'label-checkbox'} ${notEnglish ? 'reverse-label-checkbox gap-3' : ''}`} dir={notEnglish ? 'rtl' : 'ltr'}>
        <input
          className="checkbox cursor-pointer"
          type="checkbox"
          checked={checked}
          disabled={disabled}
          data-testid={'check-box'}
          id={id || label} // Set the unique ID here
          onChange={() => handelCheckBox?.(label || "", checked)} // Safely invoke the function
        />
        <label
          data-testid={id || label}
          htmlFor={id || label} // Match the `htmlFor` attribute to the input's ID
          className={`inline-block ml-1 ${textClassName || 'text-[14px] leading-[22px]'} ${fontWeight || 'font-[400]'} ${disabled ? 'text-disable_stroke' : textClassName ? textClassName : 'text-primary_text cursor-pointer'}`}
          >
          {translate(label)}
        </label>
      </div>}
    </PTagFramer>
  );
}
